import {
  React,
  Component,
  PropTypes,
} from 'imports/CommonImports';

import {
  GreyColor1,
  GreyColor2,
  SuccessColorLight,
  PrimaryColor1,
  ShadowColor,
} from 'imports/DesignImports';

import {
  Paper,
  SelectField,
  MenuItem,
} from 'material-ui';

import ReactHighcharts from 'react-highcharts';

const styles = {
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    minWidth: '20em',
  },
  header: {
    marginLeft: '1em',
  },
  selectContainer: {
    display: 'flex',
    alignItems: 'center',
  }
}

class ProjectDistributionPie extends Component {
  constructor(props){
    super(props);
    this.state = {
      now: new Date(Date.now()),
      colors: [SuccessColorLight,  PrimaryColor1, GreyColor1, ShadowColor,],
      total_per_year: this.props.data.map(data => data.values).reduce((v1, v2, i) => {
        return v1.map((value, i) => value + v2[i])
      }),
      selectedIndex: 0,
      years: [(new Date(Date.now())).getFullYear() - 1, (new Date(Date.now())).getFullYear(), (new Date(Date.now())).getFullYear() + 1],
    }
  }


  render() {
    this.props.data.map((data) => {
      return {
        name: data.name,
        y: parseFloat((data.values[this.state.selectedIndex]/this.state.total_per_year[this.state.selectedIndex]*100).toFixed(2)),
      }
    })

    return (
      <Paper style={{...styles.paper, ...this.props.style}}>
        <div style={styles.headerContainer}>
          <p style={styles.header}><b>{this.props.title} </b></p>
          <div style={styles.selectContainer}>
            Año:
            <SelectField value={this.state.selectedIndex} onChange={this.changeSelector} style={{width: 'auto', marginLeft: '1em'}} underlineStyle={{display: 'none'}}>
              {this.state.years.map((year, i) => {
                return <MenuItem key={i} value={i} primaryText={year}/>
              })}
            </SelectField>
          </div>
        </div>

        <ReactHighcharts config={this.config()} ref="chart"/>
      </Paper>
    );
  }

  changeSelector = (event, index, value) => {
    this.setState({
      selectedIndex: index
    })
  }

  config = () => {
    return {
      chart: {
          type: 'pie',
          backgroundColor: GreyColor2,
      },
      title: {
          text: '',
      },
      tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                  enabled: false
              },
              showInLegend: true,
              dataLabels: {
                  enabled: true,
                  color: (ReactHighcharts.theme && ReactHighcharts.theme.dataLabelsColor) || 'white',
                  formatter: function () {
                    var string = parseInt(this.percentage, 10) + '%';
                    return string;
                  }
              },
          }
      },
      series: [{
          name: 'Aporte al índice',
          colorByPoint: true,
          data: this.props.data.map((data) => {
            return {
              name: data.name,
              y: parseFloat((data.values[this.state.selectedIndex]/this.state.total_per_year[this.state.selectedIndex]*100).toFixed(2)),
            }
          })
      }]
    }
  }
}

ProjectDistributionPie.propTypes = {
  style: PropTypes.object,
  title: PropTypes.string,
  data: PropTypes.array,
  indicator: PropTypes.string,
  currency: PropTypes.string,
}

ProjectDistributionPie.defaultProps = {
  style: {},
  title: 'Distribución del aporte económico por proyecto año',
  data: [
      {name: 'Digitalización de procesos financieros', values: [100, 200, 300]},
      {name: 'Producción en seco de fruta', values: [200, 300, 400]},
      {name: 'Riego automatizado para campos en pendiente', values: [300, 400, 500]},
    ],
  indicator: 'EBITDA',
  currency: 'CLP',
}
export default ProjectDistributionPie;



// WEBPACK FOOTER //
// ./src/components/dashboard/ProjectDistributionPie.js